import { mutatorAction } from "satcheljs";
import categoryStore from "../store/store";

/**
 * Sets the shouldShowAllCategories flag
 * @param shouldShow new flag to set
 */
const setShouldShowAllCategoriesMutator: (shouldShow: boolean) => void = mutatorAction("setShouldShowAllCategories", function setShouldShowAllCategories(shouldShow: boolean): void {
    categoryStore().categoryMenuViewState.shouldShowAllCategories = shouldShow;
});
export default setShouldShowAllCategoriesMutator;
